import { useEffect } from "react";
import { authApi } from "@/lib/api";
import { useAppStore } from "@/store/useAppStore";

const KEEPALIVE_MS = 4 * 60 * 1000;
const RECENT_ACTIVITY_MS = 2 * 60 * 1000;

/** Extends the server idle session while the user is actively using the app. */
export function SessionActivityBridge() {
  const isAuthed = useAppStore((s) => s.isAuthed);

  useEffect(() => {
    if (!isAuthed) return undefined;

    let lastActivity = Date.now();
    const bump = () => { lastActivity = Date.now(); };

    const events = ["pointerdown", "keydown", "touchstart", "scroll"];
    events.forEach((name) => window.addEventListener(name, bump, { passive: true }));

    const tick = async () => {
      if (document.visibilityState === "hidden") return;
      if (Date.now() - lastActivity > RECENT_ACTIVITY_MS) return;
      try {
        await authApi.me();
      } catch {
        /* useAppStore refreshAuth / RequireAuth handle confirmed expiry */
      }
    };

    const timer = window.setInterval(tick, KEEPALIVE_MS);
    return () => {
      window.clearInterval(timer);
      events.forEach((name) => window.removeEventListener(name, bump));
    };
  }, [isAuthed]);

  return null;
}
